var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPmLock(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 477"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon (Stroke)",
    d: "M11.7805 7.65894C11.7805 7.37178 11.5501 7.15114 11.2922 7.15114H4.70716C4.44934 7.1512 4.2195 7.37182 4.21948 7.65894V13.2652C4.21948 13.5523 4.44933 13.7735 4.70716 13.7736H11.2922C11.5501 13.7736 11.7805 13.5524 11.7805 13.2652V7.65894ZM7.39026 11.0753V9.60394C7.39026 9.26528 7.66325 8.99074 8 8.99074C8.3367 8.99081 8.60974 9.26532 8.60974 9.60394V11.0753C8.60974 11.4139 8.3367 11.6884 8 11.6885C7.66325 11.6885 7.39026 11.4139 7.39026 11.0753ZM8 3.2264C6.53862 3.2264 5.34512 4.41554 5.31809 5.92473H10.6813C10.6543 4.41558 9.46132 3.22647 8 3.2264ZM13 13.2652C13 14.2114 12.2417 15 11.2922 15H4.70716C3.7578 14.9999 3 14.2114 3 13.2652V7.65894C3.00001 6.92762 3.45344 6.2925 4.09742 6.0409V5.97683C4.09753 3.78394 5.83031 2 8 2C10.1696 2.00007 11.9019 3.78398 11.902 5.97683V6.04031C12.5462 6.29176 13 6.92743 13 7.65894V13.2652Z",
    fill: "var(--fill-0, white)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPmLock);
export default __webpack_public_path__ + "static/media/pm-lock.c76a6fec5fe0ed49df759e4cadae6790.svg";
export { ForwardRef as ReactComponent };